import { PayloadAction } from "@reduxjs/toolkit";
import { ReduxHelper } from "helpers";
import { IBaseReducerState } from "helpers/reduxHelpers";
import { IReceiveDetail } from "model";
import { IPaginateApiResponse } from "model/Common/IPaginateApiResponse";
import { IImportPalletDetail } from "model/IReceive/IImportPalletDetail";
import { IReceiveDocument } from "model/IReceive/IReceive";
import { ReceiveActions } from "redux/actions";

interface IBaseReceive<T> {
  data?: T;
  action: string;
}
interface IReceiveState extends IBaseReducerState {
  receive?: IPaginateApiResponse<IReceiveDocument[]>;
  receiveDetail: IBaseReceive<IPaginateApiResponse<IReceiveDetail[]>>;
  palletDetail: IBaseReceive<IPaginateApiResponse<IImportPalletDetail[]>>;
}

const initialState: IReceiveState = {
  action: ReceiveActions.prefix,
  prefix: ReceiveActions.prefix,
  receiveDetail: {
    action: "RECEIVE_DOCUMENT_DETAIL",
  },
  palletDetail: {
    action: "IMPORT_PALLET_DETAIL",
  },
};

const getAllReceivesSuccess = (
  state: IReceiveState,
  action: PayloadAction<IPaginateApiResponse<IReceiveDocument[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.receive = action.payload;
  });

const getReceiveDetailSuccess = (
  state: IReceiveState,
  action: PayloadAction<IPaginateApiResponse<IReceiveDetail[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.receiveDetail.data = action.payload;
    state.receiveDetail.action = action.type;
  });
const getImportDetailSuccess = (
  state: IReceiveState,
  action: PayloadAction<IPaginateApiResponse<IImportPalletDetail[]>>
) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.palletDetail.data = action.payload;
    state.palletDetail.action = action.type;
  });

const clearAction = (state: IReceiveState, action: PayloadAction) =>
  ReduxHelper.handleReducerBuilder(state, action, () => {
    state.action = ReceiveActions.prefix;
  });

const GeneralReducer = ReduxHelper.createHandleReducer(
  initialState,
  (builder) => {
    builder.addCase(
      ReceiveActions.getAllReceives.success,
      getAllReceivesSuccess
    );
    builder.addCase(
      ReceiveActions.getReceiveDetail.success,
      getReceiveDetailSuccess
    );
    builder
      .addCase(
        ReceiveActions.getImportPalletDetail.success,
        getImportDetailSuccess
      )
      .addCase(ReceiveActions.clearAction.request, clearAction);
  }
);

export default GeneralReducer;
